module.exports = __webpack_public_path__ + "static/media/15-2.ade74a55.mp3";